import { z } from "zod";
import { translate } from "@clearabee/i18n";

export const getValidation = (products: { sku: string }[]) =>
  z
    .object({
      products: z.object(
        products.reduce(
          (final, curr) => ({
            ...final,
            [curr.sku]: z.number().optional().default(0),
          }),
          {},
        ),
      ),
    })
    .superRefine(({ products }, ctx) => {
      if (!Object.entries(products).filter(([sku, qty]) => !!qty).length) {
        ctx.addIssue({
          message: translate("hwa.screens.selectProduct.noItemsSelected"),
          code: "custom",
          path: ["noItemsSelected"],
        });
      }
    });
